import { ReactNode, useRef } from "react";
import { Dialog as NDSDialog } from "@narmi/design_system";
import { NotificationContextProvider } from "../NotificationContext";
import { useSetChatVisibility } from "../ChatVisibilityContext";

interface DialogProps {
  children: ReactNode;
  isOpen?: boolean;
  title: ReactNode;
  onUserDismiss?: () => void;
  // "plain" has no NDS styles; it works by opting out of the
  // default bordered header class
  headerStyle?: "bordered" | "banner" | "plain";
  footer?: ReactNode;
  width?: string;
  testId?: string;
}

const Dialog = ({
  children,
  isOpen,
  title,
  onUserDismiss,
  headerStyle,
  footer,
  width,
  testId,
}: DialogProps) => {
  const dialogIdRef = useRef(`Dialog-${Math.random().toString(36).substr(2, 9)}`);
  useSetChatVisibility(dialogIdRef.current, !isOpen);

  return (
    <NDSDialog
      isOpen={isOpen}
      // @ts-expect-error -- NDS types title as string, but it renders any ReactNode fine
      title={title}
      onUserDismiss={onUserDismiss}
      headerStyle={headerStyle}
      footer={footer}
      width={width}
      testId={testId}
    >
      <NotificationContextProvider isPortaled={false}>{children}</NotificationContextProvider>
    </NDSDialog>
  );
};

export default Dialog;
